import { InputGroup, Assignee, Group, ContactInfo } from 'types/groupService';

export function buildInputGroupFromGroup(group: Group): InputGroup {
  // Omit type property in AOR interface using IIFE
  const agentOfRecord = group.agentOfRecord
    ? (({ type: _, ...rest }): Omit<Assignee, 'type'> => rest)(group.agentOfRecord)
    : { id: '', name: '' };

  return {
    id: group.id,
    source: group.source,
    name: group.name,
    contactInfo: {
      firstName: group.contactInfo.firstName,
      lastName: group.contactInfo.lastName,
      primaryPhone: group.contactInfo.primaryPhone,
      primaryEmail: group.contactInfo.primaryEmail,
      primaryAddress: {
        city: group.contactInfo.primaryAddress.city,
        street: group.contactInfo.primaryAddress.street,
        street2: group.contactInfo.primaryAddress.street2,
        zip: group.contactInfo.primaryAddress.zip,
        state: group.contactInfo.primaryAddress.state,
        county: group.contactInfo.primaryAddress.county,
      },
    },
    agentOfRecord,
    accountRepresentative: group.accountRepresentative,
    effectiveDate: '',
  };
}

/**
 * Converts contact information into a list of key-value pairs
 * Used in the more info popover.
 * @param contactInfo - Group contact information object.
 * @returns Array of key-value pairs.
 */
export function buildGroupContactInfoMap(contactInfo: ContactInfo | null): Record<string, string> | null {
  if (!contactInfo) return null;

  return {
    name:
      contactInfo.firstName || contactInfo.lastName
        ? `${contactInfo.firstName || ''} ${contactInfo.lastName || ''}`
        : '',
    phone: contactInfo.primaryPhone || '',
    email: contactInfo.primaryEmail || '',
    title: contactInfo.title || '',
  };
}
